import React from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';

const styles = theme => ({
    root: {
        height: '100%',
        width: 240,
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    buttonsContainer: {
        marginLeft: 25,
        marginTop: 35,
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 20px',
        marginBottom: 20,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
});

class EditCentroUsuario extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            id: this.props.centro.id ? this.props.centro.id : uuidv4(),
            usuarioId: this.props.centro.usuarioId ? this.props.centro.usuarioId : this.props.usuarioId,
            iPerfil: this.props.centro.iPerfil ? this.props.centro.iPerfil : 1,
            centroId: this.props.centro.centroId ? this.props.centro.centroId : this.props.centros[0].id,
            
        };
    };

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: parseInt(event.target.value) });
    };

    fillCentrosOptions = () => {
        return this.props.centros.map((c, i) => {
            return (<option key={"centro_" + i} value={c.id}>{c.centro}</option>)
        })
    }

    fillPerfilesOptions = () => {
        return this.props.perfiles.map((c, i) => {
            return (<option key={"perfil_" + i} value={c.id}>{c.perfil}</option>)
        })
    }

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>

                        <InputLabel htmlFor="centro-placeholder">Centro</InputLabel>
                        <Select
                            native
                            value={this.state.centroId}
                            onChange={(event) => this.handleValueChange(event,'centroId')}
                            name="centro"
                            input={<Input id="centros" />}
                        >
                            {this.fillCentrosOptions()}
                        </Select>

                    </FormControl>
                </div>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>

                        <InputLabel htmlFor="centro-placeholder">Perfil</InputLabel>
                        <Select
                            native
                            value={this.state.iPerfil}
                            onChange={(event) => this.handleValueChange(event, 'iPerfil')}
                            name="perfil"
                            input={<Input id="perfiles" />}
                        >
                            {this.fillPerfilesOptions()}
                        </Select>

                    </FormControl>
                </div>

                <div className={classes.buttonsContainer}>
                    <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={() => this.props.hideDialog()}>Cerrar</Button>
                    <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                        const centro = {

                            id: this.state.id,
                            usuarioId: this.state.usuarioId,
                            iPerfil: this.state.iPerfil,
                            centroId: this.state.centroId

                        };

                        if (this.props.checkCentro(centro)) {

                            this.props.okHandler(centro);
                            this.props.hideDialog();
                        };
                    }
                    }>Guardar</Button>
                </div>

            </div>
        );

    };


};

EditCentroUsuario.propTypes = {
    centro: PropTypes.object.isRequired,
    usuarioId: PropTypes.number.isRequired,
    perfiles: PropTypes.object.isRequired,
    centros: PropTypes.object.isRequired,
    okHandler: PropTypes.func.isRequired,
    checkCentro: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,

};

export default withStyles(styles, { withTheme: true })(EditCentroUsuario);